module.exports = __webpack_public_path__ + "static/img/14_社區行事曆.52da205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/button/14_社區行事曆.png
// module id = Pr/R
// module chunks = 1